import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    height: 100%;
    justify-content: center;
    padding-bottom: 5%;
    text-align: center;
    width: 100%;
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    padding: 0 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};

      br {
        display: none;
      }
    }
  `}
`;

export const WrapperButton = styled.div`
  padding: 8px 0 0 0;
`;
